import http from '../../config/http-common';
import EntityPersonType from "@/model/types/modules/general/EntityPersonType";
class service {

    getResume(entityPersonType, type, param, allStatus = false) {

        const path = EntityPersonType.getPath(entityPersonType);

        return http.getResume(path,type,param,allStatus);


    }

}

export default new service()


